import { useTranslation } from 'next-i18next'

import { Section } from '@/components/exercises/Exercise/Section/Section'
import { ExerciseCard } from '@/components/exercises/ExerciseCard/ExerciseCard'
import type { ExerciseListItem } from '@/utils/exercises'

import { StyledGrid } from './RelatedExercises.Styled'

type RelatedExercisesProps = {
  exercises: ExerciseListItem[]
}

export const RelatedExercises = ({ exercises }: RelatedExercisesProps) => {
  const { t } = useTranslation()

  if (exercises.length === 0) {
    return null
  }

  return (
    <Section title={t('landing_exercises_related')}>
      <StyledGrid>
        {exercises.map((exercise) => (
          <ExerciseCard key={exercise.code} exercise={exercise} />
        ))}
      </StyledGrid>
    </Section>
  )
}
